export function pluralize(units: number, word: string): string {
  return units === 1 ? word : `${word}s`;
}

export function capitalizeFirstLetter(string: string = ''): string {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function capitalizeWords(string: string = ''): string {
  return string
    .split(' ')
    .map(word => capitalizeFirstLetter(word))
    .join(' ');
}

export const stringWithFallback = (text?: string | null, fallback?: string | null) => {
  return text ?? fallback ?? '';
};
